module.exports = __webpack_public_path__ + "static/media/txt_cover1.248ee2fa.png";